import React, { Component } from "react";
import { Link } from "react-router-dom";

class SecureContainer extends Component {
  render() {
    return (
      <div className="wrapper-page">
        <div className="text-center">
          <Link to="/" className="logo-lg">
            <img
              src="/assets/images/masar-brand.png"
              alt="Brand"
              style={{ maxWidth: "250px", marginBottom: "16px" }}
            />
          </Link>
        </div>
        {!!this.props.title && (
          <h4
            className="text-center text-primary"
            style={{
              marginTop: "16px",
              marginBottom: "16px",
              fontWeight: "900",
            }}
          >
            {this.props.title}
          </h4>
        )}
        {this.props.children}
      </div>
    );
  }
}

export default SecureContainer;



// WEBPACK FOOTER //
// ./src/components/SecureContainer.js